import ExpenseAccountForm from "../../components/AccountComponents/ExpenseAccountForm";

function NewExpenseAccountPage() {
  return <ExpenseAccountForm method="post" title="Expense" />;
}

export default NewExpenseAccountPage;